import { FC } from 'react';
import styled from 'styled-components';
import Loader from 'components/Loader';

const AppLoading: FC = () => {
  return (
    <Wrapper>
      <Loader />
    </Wrapper>
  );
};

export default AppLoading;

const Wrapper = styled.div`
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
`;
